<script setup>
import { onMounted } from "vue"
import { ref } from "@vue/reactivity"
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import router from "../router"
import { MESSAGES } from "../messages"

const userId = ref(null)
const photo = ref(null)
const accept = ref(null)

async function Accept() {
  if (accept.value !== true) {
    Gems.Telegram(MESSAGES.ERROR.PRIVACY, "tele-info", "")
    return
  }

  await KNOLIA.CallBackEnd("post", "policy-control", {
    photo: photo.value,
    user_id: userId.value,
  })
  router.push({ name: "Home" })
}

async function GetPolicy() {
  await KNOLIA.CallBackEnd("get", "policy-control").then((res) => {
    if (res.data.length > 1) {
      accept.value = true
      photo.value = res.data[0]
      userId.value = res.data[1]
    } else {
      photo.value = false
      userId.value = res.data[0]
    }
  });
}

onMounted(() => {
  GetPolicy()
})

</script>



<template>
  <div class="py-5">
    <div class="mx-auto p-5 shadow rounded border border-1 div-inner-container">
      <div id="logo-knolia" class="div-logo"></div>
      <h1 class="text-center text-uppercase mb-4 h1-title">
        Informação sobre o Sistema
      </h1>

      <div class="div-text mb-4">
        <p>
          O Sistema KNOLIA é um sistema concebido para proporcionar a gestão do potencial humano residente na empresa, consubstanciado na disponibilização continua e atualizada das competências (saberes fazer) detidas pelos/as colaboradores/as e respetivos níveis de proficiência. 
        </p>
        <p>
          Adicionalmente suporta ainda a atribuição de funções e atividades aos diversos postos de trabalho e, e em articulação com a informação sistematizada sobre as competências, permite o apuramento de ‘gaps’ de competência, bem como informação sobre perspetivas de rentabilização do potencial residente e, para cada colaborador/a, ‘insights’ valiosos sobre pistas de desenvolvimento profissional. 
        </p>
        <p>
          A sua Organização/Empresa adotou este Sistema, com o fim de orientar, acompanhar e rentabilizar as suas competências no enquadramento das funções que lhe são atribuídas e também como ‘input’ dos processos de formação e desenvolvimento e gestão de carreiras.        </p>
        <p>
          Se conseguiu aceder, isso significa que a sua Organização/Empresa o/a registou como utilizador/a e que está ativo/a no sistema KNOLIA.
        </p>
        <p>
          Este sistema também lhe é dirigido, e assim estará aberto à sua consulta no sentido de constituir um auxiliar ou mesmo um guia para o seu desenvolvimento pessoal e profissional, pelo que esperamos que se torne um ativo protagonista desses processos e também um utilizador assíduo deste sistema. 
        </p>
        <p>
          A utilização de sistemas desta natureza e com estes objetivos é legítima no âmbito das relações contratuais de trabalho subordinado e não carece de consentimento pessoal relativamente aos dados pessoais necessários.  
        </p>
        <p>
          Quando estejam em causa outras finalidades específicas, ainda que conexas, designadamente, facilitar a imediata identificação da pessoa através da utilização de uma fotografia de rosto, para as quais não haja outro fundamento de licitude, os dados pessoais só serão utilizados mediante autorização expressa do respetivo titular dos dados. 
        </p>
        <p>
          Considerando a relevância da informação contida em qualquer sistema de Gestão de Competências, a informação, incluindo os registos de avaliação de proficiência e respetivos documentos de sustentação dessa proficiência, será guardada e conservada na base de dados enquanto estiver ativo/a no sistema, e durante um período de 13 meses, depois de, eventualmente, permanecer desativado/a ininterruptamente. Depois desse período, toda a informação que lhe diga respeito será automaticamente anonimizada neste sistema. 
        </p>
        <p>
          Todos os dados e informação contida na base de dados, estão encriptados, bem como as comunicações associadas. 
        </p>
        <p>
          Por outro lado, o sistema proporciona-lhe um acesso personalizado, protegido por uma password definida por si, que pode alterar em qualquer momento.           
        </p>

        <br>
        <p class="fw-bold">
          Informação sobre algoritmos nos sistemas KNOLIA 
        </p>

        <p>
          “Algoritmos são sequências finitas de ações executáveis que visam obter uma solução para um determinado tipo de problema”. 
        </p>
        <p>
          No âmbito do sistema KNOLIA, os algoritmos estão presentes através de cálculos que o sistema executa para apurar os níveis de proficiência das competências num dado momento. Importa referir que esses cálculos são efetuados com base em fórmulas que utilizam apenas classificações e avaliações produzidas pelo próprio utilizador, comparando-as eventualmente com requisitos previamente quantificados pela sua Organização, relativamente a atividades profissionais de forma geral e não personalizada. 
        </p>
        <p>
          Está disponível uma explicação sobre como operar este Sistema, diretamente acessível através das “Ajudas” disponibilizadas aos/às utilizadores/as e administradores da ferramenta. 
        </p>
        <p>
          Os sistemas CIRVALUE são disponibilizados à sua Organização/Empresa de forma que sejam geridos sem intervenção de pessoas externas, nomeadamente trabalhadores do fabricante ou de entidades terceiras que possam comercializar os sistemas. 
        </p>
        <p>
          Sugerimos, assim, que contacte o/a Administrador/a KNOLIA ou a área de Proteção de Dados da sua Organização/Empresa, para obter mais informações sobre a parametrização internamente definida, designadamente, as permissões definidas, as pessoas que podem ter acesso à informação que lhe diga respeito e outros aspetos relacionados com privacidade ou proteção dos dados pessoais tratados pela sua Organização/Empresa. 
        </p>
        <!--<p>
          Obtenha informação de apoio sobre como utilizar o KNOLIA, acedendo às informações do separador “AJUDA” disponibilizado no menu.
        </p>-->
        <p>
          Consulte a Política de Privacidade e Proteção de Dados da INCENTEA (Fabricante). 
        </p>
        <br>
        <p>
          Para prosseguir a sua experiência no KNOLIA, preencha os campos abaixo.
        </p>
      </div>
      
      <form class="mb-4">
        <div class="form-check mb-3 d-flex">
          <input class="form-check-input cursor-pointer" type="checkbox" id="accept" v-model="accept"/>

          <label class="form-check-label ms-2 fs-6" for="accept">
            Tomei conhecimento e entendi a informação prestada (obrigatório para prosseguir a experiência no KNOLIA)
          </label>
        </div>

        <div class="form-check mb-4 d-flex">
          <input class="form-check-input cursor-pointer" type="checkbox" id="photo" v-model="photo"/>

          <label class="form-check-label ms-2 fs-6" for="photo">
            Autorizo a utilização da minha fotografia, como forma de facilitar a minha identificação inequívoca pelos restantes utilizadores (esta autorização é facultativa e poderá retirar a mesma em qualquer momento)
          </label>
        </div>
      </form>

      <!--
      <div class="div-text mb-4">
        <p>
          Se ativou a opção “Sim”, o seu consentimento fica registado e, da próxima vez que entrar no sistema, esta opção continuará ativa. 
        </p>
        <p>
          Se quiser retirar o consentimento anteriormente prestado, basta ativar a opção “Não” acedendo ao menu “Privacidade” e a sua fotografia deixará de aparecer. 
        </p>
      </div>
      -->

      <button class="btn btn-primary w-100 fs-6" :class="{ disabled: !accept }" @click="Accept">
        PROSSEGUIR EXPERIÊNCIA NO KNOLIA
      </button>
    </div>
  </div>
</template>

<style scoped>

#logo-knolia {
  padding: 15px;
  height: 150px;
  background-image: url("../images/logo.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 30px;
}

.div-inner-container {
  max-width: 800px;
}

.h1-title {
  letter-spacing: 0.3em;
}

button {
  letter-spacing: .2em;
}

.div-text {
  text-align: justify;
  letter-spacing: 0.08em; font-size: 1.1em;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

label {
  letter-spacing: 0.08em;
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e") !important;
}
</style>
